import React from "react";
import "./NotNtworkItem.scss";
import img from "../../../Assets/NotNetwork/img/Vector.png";
const NotNtworkItem = ({price}) => {
  const langGlobal = localStorage.getItem('lang')
  const lang = {
    titleTJ: 'Салом!',
    titleRU: 'Здравствуйте!',
    internetTJ: 'Интернети шумо муваққатан хомӯш шудааст, зеро дар тавозун маблағ намерасад.',
    internetRU: 'Ваш интернет временно приостановлен из-за недостатка средств на балансе.',
    banlanceTJ: `Лутфан тавозуни худро ба маблағи ${price} TJS пур кунед, то ки хизматрасонии интернет барқарор шавад.`,
    banlanceRU: `Чтобы восстановить доступ, пополните счет на ${price} TJS.`,
    subTitleTJ: 'Агар савол дошта бошед, ба мо муроҷиат кунед. Рақамҳои барои тамос 418004848 ё 4848 занг занед!',
    subTitleRU: 'Если у вас есть вопросы, позвоните по номерам 418004848 или 4848. Мы всегда готовы помочь!',

  }
  return (
    <div className="notNtworkItem_block">
      <img src={img} alt="" />
      <div className="notNtworkItem_item">
        <div className="notNetwork_text">
          <p>{langGlobal === 'TJ' ? lang.titleTJ : lang.titleRU}</p>
          <p>
          {langGlobal === 'TJ' ? lang.internetTJ : lang.internetRU}
          </p>
          <h4>📌 {langGlobal === 'TJ' ? lang.banlanceTJ : lang.banlanceRU}</h4>
        </div>
        <div className="notNetwork_text">
          <p>
          {langGlobal === 'TJ' ? lang.subTitleTJ : lang.subTitleRU}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotNtworkItem;
